import { render, staticRenderFns } from "./NumberInfo.vue?vue&type=template&id=6d0b3462"
import script from "./NumberInfo.vue?vue&type=script&lang=js"
export * from "./NumberInfo.vue?vue&type=script&lang=js"
import style0 from "./NumberInfo.vue?vue&type=style&index=0&id=6d0b3462&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d0b3462')) {
      api.createRecord('6d0b3462', component.options)
    } else {
      api.reload('6d0b3462', component.options)
    }
    module.hot.accept("./NumberInfo.vue?vue&type=template&id=6d0b3462", function () {
      api.rerender('6d0b3462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/numberInfo/NumberInfo.vue"
export default component.exports